<form class="k-form" #receiptForm="ngForm" novalidate>
  <p>Would you like to email a receipt?</p>
  <kendo-textbox class="w-100" #emailAddressInput name="emailAddressInput" [disabled]="isEmailAddressInputDisabled()" [(ngModel)]="emailAddress" [pattern]="getEmailAddressPattern()">
  </kendo-textbox>
  <button kendoButton class="button-primary" [disabled]="isSendButtonDisabled() || !receiptForm.valid" (click)="onSendButtonClick()">
    Send
  </button>
  <p *ngIf="receiptSent" class="green">Receipt has been sent to the specified email address.</p>
  <p *ngIf="isErrorMessageVisible()" class="red text-center">{{sendErrorMessage}}</p>
</form>